import { PUBLIC_SITE_NAME } from '$env/static/public';

const links = {
	quick: [
		{
			label: `Tentang ${PUBLIC_SITE_NAME}`,
			url: '/about'
		},
		{
			label: 'Bantuan',
			url: '/help'
		},
		{
			label: 'Jadi Penulis',
			url: '/be-writer'
		},
		{
			label: 'Redeem',
			url: '/redeem'
		}
	],
	document: [
		{
			label: 'Tentang Kami',
			url: '/about'
		},
		{
			label: 'Kebijakan Privasi',
			url: '/privacy-policy'
		},
		{
			label: 'Syarat dan Ketentuan',
			url: '/terms-conditions'
		}
	]
};

export { links };
